import React, { useState } from 'react';
import Compiler from '../compiler/Compiler';

const KovCollapsed = ({ item, color, children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const customColor = isOpen ? color : null;

  return (
    <div className="kov-collapsed kov-pro-inline-accordion">
      <div className="kov-pro-inline-accordion__question">
        <div
          className="kov-pro-inline-accordion__question-header"
          onClick={() => setIsOpen(!isOpen)}
        >
          <button
            className={`btn btn-link ${isOpen ? 'collapsed' : ''}`}
            aria-expanded={isOpen}
            style={{ borderLeftColor: customColor ?? 'transparent' }}
          >
            <h4 style={{ color: customColor ?? 'inherit' }}>
              <Compiler text={item.title} options={{ filterHTML: true }} />
            </h4>
          </button>
        </div>

        {isOpen && (
          <div className="collapse show">
            <div
              className="kov-pro-inline-accordion__question-body"
              style={{ borderLeftColor: color }}
            >
              {children}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default KovCollapsed;
